import { useState } from 'react';
import { toast } from '../use-toast';
import { showErrorToast } from '../../utils/errorHandler';

/**
 * Custom hook to manage ride cancellation logic
 */
export const useRideCancellation = (ride, onCancellationSuccess) => {
  const [showCancelDialog, setShowCancelDialog] = useState(false);
  const [cancellationReason, setCancellationReason] = useState('');
  const [cancelling, setCancelling] = useState(false);

  const openCancelDialog = () => {
    setShowCancelDialog(true);
  };

  const closeCancelDialog = () => {
    setShowCancelDialog(false);
    setCancellationReason('');
  };

  const handleCancelRide = async () => {
    if (!cancellationReason) {
      toast({
        title: 'Reason Required',
        description: 'Please select a cancellation reason',
        variant: 'destructive',
      });
      return;
    }

    setCancelling(true);

    try {
      const api = (await import('../../utils/api')).default;
      const response = await api.post('/drivers/ride-action', {
        rideId: ride.id,
        action: 'cancel',
        cancellationReason
      });

      toast({
        title: 'Ride Cancelled',
        description: response.data.message,
      });

      closeCancelDialog();
      
      if (onCancellationSuccess) {
        onCancellationSuccess();
      }
    } catch (error) {
      console.error('Error cancelling ride:', error);
      showErrorToast(toast, error, 'Failed to cancel ride');
    } finally {
      setCancelling(false);
    }
  };

  return {
    showCancelDialog,
    cancellationReason,
    setCancellationReason,
    cancelling,
    openCancelDialog,
    closeCancelDialog,
    handleCancelRide,
  };
};
